import { render } from "./MusicIcon.vue?vue&type=template&id=b6ce9cf2"
import script from "./MusicIcon.vue?vue&type=script&lang=js"
export * from "./MusicIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__